(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[ä]/g, 'ae')
      .replace(/[ö]/g, 'oe')
      .replace(/[ü]/g, 'ue')
      .replace(/[ß]/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initArticle(root) {
    var content = root.querySelector('[data-article-content]');
    var tocLists = root.querySelectorAll('[data-article-toc-list]');
    if (!content || !tocLists.length) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (!headings.length) {
      root.classList.remove('has-toc');
      root.querySelectorAll('[data-article-toc]').forEach(function (toc) {
        toc.hidden = true;
      });
      return;
    }

    var used = {};
    var linksById = {};
    var currentId = '';
    var lockedId = '';
    var unlockTimer = null;
    var ticking = false;
    var activationOffset = 150;

    function updateStickyOffset() {
      var articleNav = root.querySelector('.article__nav');
      var gap = 28;
      var offset = 120;

      if (articleNav) {
        var navStyles = window.getComputedStyle(articleNav);
        var navTop = parseFloat(navStyles.top);

        if (Number.isNaN(navTop)) navTop = 0;

        offset = Math.max(120, navTop + articleNav.offsetHeight + gap);
      }

      activationOffset = offset;
      root.style.setProperty('--mb-article-sticky-offset', offset + 'px');
    }

    headings.forEach(function (heading, index) {
      var base = heading.id || slugify(heading.textContent) || ('abschnitt-' + (index + 1));
      var id = base;
      var suffix = 2;

      while (used[id]) {
        id = base + '-' + suffix;
        suffix += 1;
      }

      used[id] = true;
      heading.id = id;
      linksById[id] = [];

      tocLists.forEach(function (list) {
        var item = document.createElement('li');
        item.className = list.dataset.mobile === 'true'
          ? 'mb-article-mobile-toc__item'
          : 'mb-article-toc__item';
        item.dataset.level = '2';

        var link = document.createElement('a');
        link.className = list.dataset.mobile === 'true'
          ? 'mb-article-mobile-toc__link'
          : 'mb-article-toc__link';
        link.href = '#' + id;
        link.textContent = heading.textContent;
        link.dataset.tocTarget = id;

        link.addEventListener('click', function (event) {
          event.preventDefault();

          var target = document.getElementById(id);
          if (!target) return;

          lockedId = id;
          setActive(id);

          if (unlockTimer) window.clearTimeout(unlockTimer);

          updateStickyOffset();

          var targetTop = window.scrollY + target.getBoundingClientRect().top - activationOffset;

          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });

          history.replaceState(null, '', '#' + id);

          unlockTimer = window.setTimeout(function () {
            lockedId = '';
            updateActive();
          }, 1200);
        });

        linksById[id].push(link);
        item.appendChild(link);
        list.appendChild(item);
      });
    });

    function setActive(id) {
      if (!id || currentId === id) return;
      currentId = id;

      Object.keys(linksById).forEach(function (key) {
        linksById[key].forEach(function (link) {
          if (key === id) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      });
    }

    function updateActive() {
      if (lockedId) {
        setActive(lockedId);
        return;
      }

      var documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
      var atPageBottom = window.scrollY + window.innerHeight >= documentHeight - 4;

      if (atPageBottom) {
        setActive(headings[headings.length - 1].id);
        return;
      }

      var activeHeading = headings[0];

      for (var i = 0; i < headings.length; i += 1) {
        if (headings[i].getBoundingClientRect().top <= activationOffset) {
          activeHeading = headings[i];
        } else {
          break;
        }
      }

      setActive(activeHeading.id);
    }

    function requestUpdate() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(function () {
        updateActive();
        ticking = false;
      });
    }

    ['wheel', 'touchstart', 'pointerdown'].forEach(function (eventName) {
      window.addEventListener(eventName, function () {
        if (!lockedId) return;
        lockedId = '';
        if (unlockTimer) window.clearTimeout(unlockTimer);
        requestUpdate();
      }, { passive: true });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      updateStickyOffset();
      requestUpdate();
    });

    updateStickyOffset();
    setActive(headings[0].id);
    updateActive();

    // Enable the sidebar only after both TOC lists have been populated.
    root.classList.add('has-toc');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mobiball-article]').forEach(initArticle);
  });
})();
